var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import AlertDialog from './AlertDialog';
import { createUserForm } from '../../../api/formService';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import { descargarPDFBase64, encodeUnicodeToBase64, htmlBase64ToPdf } from '../../../api/printService';
import { useAuthStore } from '../../../application/stores/auth.store'; // ✅ Nuevo hook
const InfoModal = ({ modalContent, modalType, showResetLink, alertContent }) => {
    const { t } = useTranslation();
    const [showAlert, setShowAlert] = useState(false);
    const modalDescription = t(modalContent === null || modalContent === void 0 ? void 0 : modalContent.description);
    const getCompanyId = useAuthStore((state) => state.getCompanyId);
    const [isDownloading, setIsDownloading] = useState(false);
    const openAlert = () => {
        setShowAlert(true);
    };
    const closeAlert = () => {
        setShowAlert(false);
    };
    const resetForm = () => __awaiter(void 0, void 0, void 0, function* () {
        if (getCompanyId() !== undefined) {
            const newForm = yield createUserForm(getCompanyId());
            if (newForm.id) {
                setShowAlert(false);
                window.location.reload();
            }
        }
    });
    const downLoadTermsAndConditions = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setIsDownloading(true);
            const html = `
                    <!DOCTYPE html>
                    <html lang="es">
                    <head>
                        <meta charset="UTF-8">
                        <title>Pago realizado</title>
                        <style>
                        @page {
                          size: A4;
                          margin: 20mm 20mm 30mm 20mm;
                        }

                        body {
                          font-family: Arial, sans-serif;
                          color: #000;
                          background: none;
                        }

                        .text-center{
                          text-align: center !important;
                        }

                        p, li {
                          text-align:justify
                        }

                        .header-logo {
                            max-width: 115px;
                            max-height: 60px;
                            margin: 0px 0 0 10px;
                            order: 0;
                            cursor: pointer;
                        }
                        
                        .legal-info {
                          font-size: 1rem;

                          p, a, span, li {
                                font-family: Poppins;
                          }

                          h1 {
                            font-weight: 700;
                            margin-top: 24px;
                          }

                          h2 {
                            font-size: var(--step-1);
                            font-weight: 700;
                            margin-top: 24px;
                          }

                          h2,
                          h3 {
                            margin-bottom: 14px;
                          }

                          h3,
                          h4 {
                            font-size: var(--step-0);
                            font-weight: 700;
                            margin: 14px 0;
                          }

                          b {
                            font-weight: 700;
                          }

                          .table {
                            text-align: left;

                            td {
                              font-size: 1rem;
                              vertical-align: middle;
                            }
                          }

                          table {
                            margin-bottom: 1rem;
                            vertical-align: top;
                            border: 1px solid #D9D9D9;
                            text-align: left;
                            width: 100%;
                            border-collapse: collapse;
                            tr {
                              page-break-inside: avoid;
                            }
                              th, td {
                              border: 1px solid #D9D9D9;
                              padding: 8px;
                              text-align: left;
                            }

                            td {
                              font-size: 1rem;
                              vertical-align: middle;
                            }
                          }

                          caption {
                            caption-side: top;
                          }

                          width: 100%;
    

                          .list-anexo {
                            list-style-type: none;
                            margin: 0;
                            padding: 0;
                            ul{
                              list-style-type: none;
                              padding-right: 20px;
                            }
                          }

                          strong{
                            font-weight: 700 !important;
                          }

                          p, li{
                            margin-bottom: 14px;
                          }

                        }
                        
    
                        </style>
                    </head>
                    <body> 
                      <div className="logo-print">
                        <img alt="SIGNO" class="header-logo" src="https://stsignostagewesteu001.blob.core.windows.net/signo-web-images-storage/Logo_Signo.svg" />
                      </div>
                      <div class="legal-info">
                        <h1>${t('legal.termsOfUseModal.title')}</h1>
                        ${t('legal.termsOfUseModal.description')}
                      </div>
                    </body>
                    </html>  
                  `;
            const htmlBase64 = encodeUnicodeToBase64(html);
            const pdfBase64 = yield htmlBase64ToPdf(htmlBase64);
            if (!pdfBase64 || typeof pdfBase64 !== 'string' || !pdfBase64.startsWith('JVBER')) {
                console.error('No se pudo generar un PDF válido');
                return;
            }
            descargarPDFBase64(pdfBase64, `terminos-condiciones-generales-signo.pdf`);
        }
        catch (error) {
            console.error('Error al generar o descargar el PDF:', error);
        }
        finally {
            setIsDownloading(false); // ✅ Reactivar el botón
        }
    });
    return (_jsx("div", Object.assign({ "data-nosnippet": true, className: "offcanvas offcanvas-start", id: modalType, "aria-labelledby": modalType, "data-testid": "info-modal" }, { children: _jsxs("div", Object.assign({ className: "info-modal__container" }, { children: [_jsxs("div", Object.assign({ className: "info-modal__content" }, { children: [_jsx("div", Object.assign({ className: "info-modal__close-btn", "data-bs-dismiss": "offcanvas", "aria-label": "Close", "data-testid": "modal-close-button" }, { children: _jsx("i", { className: "bi bi-x info-modal__close-btn-icon" }) })), _jsxs("div", Object.assign({ className: "offcanvas-body info-modal__body" }, { children: [_jsxs("h1", Object.assign({ "data-nosnippet": true, className: "info-modal__body__title main-title", "data-testid": "modal-title" }, { children: [t(modalContent === null || modalContent === void 0 ? void 0 : modalContent.title), (modalContent === null || modalContent === void 0 ? void 0 : modalContent.title) === 'legal.termsOfUseModal.title' && _jsx(Button, Object.assign({ className: 'btn-download', type: "button", variant: 'contained', disabled: isDownloading, onClick: downLoadTermsAndConditions, startIcon: _jsx(PrintOutlinedIcon, {}) }, { children: t('common.btn.download') }))] })), _jsxs("div", Object.assign({ className: "info-modal__body__description", "data-testid": "modal-description" }, { children: [_jsx("div", { "data-nosnippet": true, className: "info-modal__body__description-main", dangerouslySetInnerHTML: { __html: modalDescription } }), showResetLink && (_jsxs("p", Object.assign({ "data-nosnippet": true, className: "info-modal__reset-link" }, { children: [modalContent === null || modalContent === void 0 ? void 0 : modalContent.resetForm.text, ' ', _jsx("a", Object.assign({ onClick: openAlert, href: "#" }, { children: t(modalContent === null || modalContent === void 0 ? void 0 : modalContent.resetForm.link) }))] }))), showAlert && _jsx(AlertDialog, { alertContent: alertContent, closeAlertDialog: closeAlert, handleAlertActionFn: resetForm }), (modalContent === null || modalContent === void 0 ? void 0 : modalContent.additionalText) && (_jsx("p", { "data-nosnippet": true, className: "info-modal__body__additional-text", "data-testid": "modal-additional-text", dangerouslySetInnerHTML: { __html: t(modalContent === null || modalContent === void 0 ? void 0 : modalContent.additionalText) } }))] }))] }))] })), _jsx("div", Object.assign({ className: "info-modal__button" }, { children: _jsx(Button, Object.assign({ onClick: () => { }, variant: "contained", color: "primary", "data-bs-dismiss": "offcanvas" }, { children: t(modalContent === null || modalContent === void 0 ? void 0 : modalContent.buttonText) })) }))] })) })));
};
export default InfoModal;
